export const types = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
};

export const showModal = modalName => ({
  type: types.SHOW_MODAL,
  modalName,
});

export const hideModal = modalName => ({
  type: types.HIDE_MODAL,
  modalName,
});
